import { useEffect, useRef } from 'react';

export default function useInterval(callback: () => void, delay: number | null): void {
  const savedCallback = useRef<() => void | null>();
  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  });

  // Set up the interval.
  useEffect(() => {
    function tick(): void {
      savedCallback?.current?.();
    }

    if (delay !== null) {
      const id = window.setInterval(tick, delay);
      return (): void => window.clearInterval(id);
    }
  }, [delay]);
}
